module.exports = __webpack_public_path__ + "img/img29.fddd8d91.svg";